module.exports = __webpack_public_path__ + "img/dropdown.2cead01a.svg";